import { useEffect, useRef } from 'react';

import debugLog from 'utils/debugLog.ts';

import { BitmovinPlayerSource } from '../../types.ts';

function useDebouncedPlayerSource(
    source: BitmovinPlayerSource,
    playerSourceLoading: boolean,
    loadPlayerSource: (source: BitmovinPlayerSource) => void,
) {
    const debouncedSource = useRef<BitmovinPlayerSource>(undefined);

    useEffect(() => {
        if (playerSourceLoading && source) {
            debugLog(
                'BITMOVIN',
                'source changed, set new source to the queue...',
                source.src,
            );

            debouncedSource.current = source;
        } else {
            debugLog('BITMOVIN', 'source changed, loading new source...');

            debouncedSource.current = undefined;
            loadPlayerSource(source);
        }
    }, [source]);

    useEffect(() => {
        if (!playerSourceLoading && debouncedSource.current) {
            debugLog(
                'BITMOVIN',
                'source changed, loading debounced source...',
                debouncedSource.current.src,
            );
            loadPlayerSource(debouncedSource.current);
            debouncedSource.current = undefined;
        }
    }, [playerSourceLoading]);
}

export default useDebouncedPlayerSource;
